export async function getFamilyMembersById(userId) {
  try {
   
    if (!userId) {
      const userData = JSON.parse(localStorage.getItem("medarphaUser"));
      userId = userData?.id || userData?.userId || userData?.UserId;
    }

    if (!userId) {
      console.error("❌ No userId found in localStorage");
      return [];
    }

    // ✅ Dynamic URL - env use karega
    const apiUrl = `${process.env.REACT_APP_API_URL}Customer/GetFamilyMemberByUserId/${userId}`;
    console.log("🌐 Fetching Family Members for User ID: ${userId}");
    console.log("🌐 URL:", apiUrl);

    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    const data = await response.json();
    console.log("✅ API Response:", data);

    // Handle both array and wrapped formats
    return Array.isArray(data) ? data : data?.data || [];
  } catch (error) {
    console.error("🚨 Error fetching family members:", error);
    return [];
  }
}